export interface IAppSettings {
    trialPortalUrl: string;
    redactUrl: string;
    ecrfUrl: string;
};

export const AppSettings: IAppSettings = {
    trialPortalUrl: (window as any).TRIAL_PORTAL_URL ?? "https://redact.breastcancertrials.org.au",
    redactUrl: (window as any).REDACT_URL_NO_SLASH ?? "https://redact.breastcancertrials.org.au",
    ecrfUrl: (window as any).ECRF_URL ?? "https://ecrf.breastcancertrials.org.au/"
};
